import React, { useState } from "react";
// import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { CircularProgress } from "@mui/material";

import commoncss from "../../myfin_v2/css/common.module.css";
import buttoncss from "../../myfin_v2/css/button.module.css";
import Modal from "../../myfin_v2/elements/Modal";
import { Button } from "../../myfin_v2/elements/Button";
import InputGroup from "../../myfin_v2/elements/InputGroup";
import { ReactComponent as CloseIcon } from "../../myfin_v2/assets/icons/close.svg";

export default function GetPresetNameModal({
  setSavePresetModal,
  SaveAsPreset,
  isSavePresetLoading,
  name,
  setName,
}) {

  return (
    <React.Fragment>
      <Modal
        title="Save as Preset"
        bodycss={commoncss.unsetPadding}
        headerActions={
          <CloseIcon
            onClick={() => {
              setSavePresetModal(false);
            }}
            className="clickable"
          />
        }
        onClose={() => console.log("Modal Closed")}
        footerActions={
          <>
            <Button
              btnColor={buttoncss.secondary}
              onClick={() => {
                setSavePresetModal(false);
              }}
              label="Cancel"
            />
            <Button
              btnColor={buttoncss.primary}
              label={
                isSavePresetLoading ? (
                  <CircularProgress style={{ height: "1rem", width: "1rem" }} />
                ) : (
                  "Save"
                )
              }
              onClick={SaveAsPreset}
            />
          </>
        }
      >
        <div className={commoncss.pd1530}>
          <InputGroup
            label="Preset Name"
            inputs={[
              <>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  name="name"
                  placeholder="preset name"
                />
              </>,
            ]}
          />
        </div>
      </Modal>
      {/* <Dialog open={isNameModal} onClose={handleClose}>
        <DialogTitle>Preset Name</DialogTitle>
        <DialogContent>
          <DialogContentText>Enter Preset Name</DialogContentText>
          <input
            style={{ width: "20rem" }}
            className="rounded"
            value={name}
            onChange={(e) => setName(e.target.value)}
            name="name"
            type="text"
            placeholder="preset name"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            style={{ width: "5rem", height: "2rem" }}
            onClick={SaveAsPreset}
          >
            {isSavePresetLoading ? (
              <CircularProgress style={{ height: "1rem", width: "1rem" }} />
            ) : (
              "Save"
            )}
          </Button>
        </DialogActions>
      </Dialog> */}
    </React.Fragment>
  );
}
